import React from "react";

const Button = ({ children, href, onClick, target, className = '' }) => {
  return (
    <button
      href={href}
      target={target}
      onClick={onClick}
      className={`btn btn-primary my-4 ${className}`}
    >
      {children}
    </button>
  );
};

export default Button;
